export default function AdminBehaviorEditQuestions() {
  return <div className="">general</div>;
}
